var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "RMApprove"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_vm._m(0), _vm._v(" "), _c('div', {}, [_c('b-card', [_c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "0px !important"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchData.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("From Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "fromDate",
      "type": "Date",
      "name": "fromDate",
      "placeholder": "Enter From Date"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("To Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "toDate",
      "type": "Date",
      "name": "toDate",
      "placeholder": "Enter To Date"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Shipment Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShipmentType),
      expression: "ShipmentType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ShipmentType",
      "id": "ShipmentType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ShipmentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-Select Shipment Type -")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Delivery"
    }
  }, [_vm._v("Delivery")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RTO"
    }
  }, [_vm._v("RTO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DTO"
    }
  }, [_vm._v("DTO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RVP"
    }
  }, [_vm._v("RVP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Hub Zone")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hubzoneid),
      expression: "hubzoneid"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "hubzoneid",
      "id": "hubzoneid"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hubzoneid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getHubsByZoneId($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Hub Zone--")]), _vm._v(" "), _vm._l((_vm.hubZoneList), function(hubZones) {
    return _c('option', {
      domProps: {
        "value": hubZones.HubZoneId
      },
      on: {
        "click": function($event) {
          return _vm.getHubList(hubZones.HubZoneId)
        }
      }
    }, [_vm._v(_vm._s(hubZones.hubzonename))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Hub State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hubStateId),
      expression: "hubStateId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "hubStateId",
      "id": "hubStateId"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hubStateId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getCitiesbyState($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Hub State--")]), _vm._v(" "), _vm._l((_vm.hubStateList), function(hubStates) {
    return _c('option', {
      domProps: {
        "value": hubStates.HubStateId
      }
    }, [_vm._v(_vm._s(hubStates.HubState))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Hub City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hubCityId),
      expression: "hubCityId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "hubCityId",
      "id": "hubCityId"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hubCityId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getHubsByCities($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Hub City--")]), _vm._v(" "), _vm._l((_vm.hubCitybyStateList), function(hubCities) {
    return _c('option', {
      domProps: {
        "value": hubCities.CityId
      }
    }, [_vm._v(_vm._s(hubCities.HubCity))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("SOC (Span of Control)")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AOR),
      expression: "AOR"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "AOR",
      "id": "AOR"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.AOR = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getHubsByAOR(_vm.AOR)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select SOC--")]), _vm._v(" "), _vm._l((_vm.AORList), function(AORid) {
    return _c('option', {
      domProps: {
        "value": AORid.SOC
      }
    }, [_vm._v(_vm._s(AORid.SOC))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Center Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CenterType),
      expression: "CenterType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CenterType",
      "id": "CenterType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CenterType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getServiceCentreList(_vm.CenterType)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Center --")]), _vm._v(" "), _vm._l((_vm.CenterTypeList), function(CenterTypes) {
    return _c('option', {
      domProps: {
        "value": CenterTypes.upper
      }
    }, [_vm._v(_vm._s(CenterTypes.upper))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Service Center")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": "--select servicecenter-",
      "label": "HubName",
      "track-by": "HubID",
      "options": _vm.filteredHubList,
      "multiple": true,
      "taggable": true,
      "loading": _vm.isLoading
    },
    model: {
      value: (_vm.hubID),
      callback: function($$v) {
        _vm.hubID = $$v
      },
      expression: "hubID"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Shipping Id")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbnumbers),
      expression: "awbnumbers"
    }],
    ref: "textarea",
    class: {
      'form-control': true,
      'error': _vm.errors.has('awbnumbers')
    },
    attrs: {
      "rows": "4",
      "name": "awbnumbers",
      "id": "awbnumbers"
    },
    domProps: {
      "value": (_vm.awbnumbers)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbnumbers = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "textarea-style",
    staticStyle: {
      "display": "block",
      "color": "blue"
    }
  }, [_vm._v(" (Note: Use comma (,) for multiple AWB numbers)\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 mt-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v(" \n                  "), _c('span', {
    staticClass: "btn btn-danger linkforspan",
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")]), _vm._v(" \n                  "), _c('span', {
    staticClass: "btn btn-primary linkforspan",
    on: {
      "click": _vm.downloadCsv
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Export")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.ExportRmApproveLoaderBtn
    },
    on: {
      "update:active": function($event) {
        _vm.ExportRmApproveLoaderBtn = $event
      }
    }
  })], 1)])])])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchflag == true),
      expression: "searchflag == true"
    }]
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 mb-2"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Total Selected : " + _vm._s(_vm.totalSelectedRecords) + "  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 mb-2"
  }, [_c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("Total Record: " + _vm._s(_vm.totalRecords) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mb-2"
  }, [_c('span', [_vm._v("Total Debit Amount: "), _c('b', [_vm._v(_vm._s(_vm.totalDebitAmount) + " ₹")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 mb-2",
    staticStyle: {
      "text-align": "end"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.selectedItems.length == 0
    },
    on: {
      "click": _vm.approveAllRecolrd
    }
  }, [_vm._v("Approve")]), _vm._v(" \n       ")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.RmApproveLoaderBtn
    },
    on: {
      "update:active": function($event) {
        _vm.RmApproveLoaderBtn = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group table-area",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "batches table-bordered table-hover tbl datatables",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "id": "batchTable",
      "cellpadding": "10",
      "cellspacing": "10"
    }
  }, [_c('thead', {
    staticClass: "thead"
  }, [_c('tr', [_c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllItems),
      expression: "selectAllItems"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllItems) ? _vm._i(_vm.selectAllItems, null) > -1 : (_vm.selectAllItems)
    },
    on: {
      "click": function($event) {
        return _vm.selectItems($event)
      },
      "change": function($event) {
        var $$a = _vm.selectAllItems,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllItems = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAllItems = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllItems = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Zone")]), _vm._v(" "), _c('th', [_vm._v("Hub Name")]), _vm._v(" "), _c('th', [_vm._v("Client")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v(" Debit From")]), _vm._v(" "), _c('th', [_vm._v("Total Shipment Value")]), _vm._v(" "), _c('th', [_vm._v("Penalty")]), _vm._v(" "), _c('th', [_vm._v("Debit Amount")]), _vm._v(" "), _c('th', [_vm._v("Debit Agency Details")]), _vm._v(" "), _c('th', [_vm._v("Debit SR Details ")]), _vm._v(" "), _c('th', [_vm._v("Docket No")]), _vm._v(" "), _c('th', [_vm._v("DebitDate")]), _vm._v(" "), _c('th', [_vm._v("LastModifedDate")]), _vm._v(" "), _c('th', [_vm._v("CreatedBy")]), _vm._v(" "), _c('th', [_vm._v("Comments")]), _vm._v(" "), _c('th', [_vm._v("Attachment")])])]), _vm._v(" "), _c('tbody', [(_vm.ShipmentData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "16",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.ShipmentData), function(val) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedItems),
        expression: "selectedItems"
      }],
      attrs: {
        "type": "checkbox",
        "name": "checkboxes"
      },
      domProps: {
        "value": val.ShipmentLostMasterID,
        "checked": Array.isArray(_vm.selectedItems) ? _vm._i(_vm.selectedItems, val.ShipmentLostMasterID) > -1 : (_vm.selectedItems)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedItems,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = val.ShipmentLostMasterID,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedItems = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedItems = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedItems = $$c
          }
        }, function($event) {
          return _vm.calculateselectedcount($event, val)
        }]
      }
    })]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.getShipmentslog(val.ShippingID)
        }
      }
    }, [_vm._v(_vm._s(val.ShippingID ? val.ShippingID : '-'))])]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.HubZoneName ? val.HubZoneName : '-'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.HubName ? val.HubName : '-'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.ClientName ? val.ClientName : '-'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.Status))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.DebitFromType ? val.DebitFromType : '-'))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.getDebitAmountPopup(val.ShipmentLostMasterID)
        }
      }
    }, [_vm._v(_vm._s(val.NetShipmentValue ? val.NetShipmentValue : '0.00'))])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link"
    }, [_vm._v(_vm._s(val.Penalty ? val.Penalty : "0.00"))])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.getDebitAmountPopup(val.ShipmentLostMasterID)
        }
      }
    }, [_vm._v(_vm._s(val.totalDebitAmount))])]), _vm._v(" "), _c('td', {
      staticClass: "word-wraptd"
    }, [(val.UniqueDebitFromList.length == 1) ? _c('p', [_vm._v(_vm._s(val.UniqueDebitFromList[0].DebitFrom) + " (" + _vm._s(val.UniqueDebitFromList[0].DebitID) + ")")]) : _c('p', [_c('button', {
      staticClass: "btn btn-primary btn-xs",
      staticStyle: {
        "border-radius": "0px",
        "padding": "0.3rem 0.5rem"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showDebitAgencyModal(val.ShippingID)
        }
      }
    }, [_vm._v("\n                 Show Details")])])]), _vm._v(" "), _c('td', {
      staticClass: "word-wraptd"
    }, [(val.DebitPersonalDetails.length == 1) ? _c('p', [_vm._v(_vm._s(val.DebitPersonalDetails[0].SRName) + " (" + _vm._s(val.DebitPersonalDetails[0].UserID) + ")")]) : _c('p', [_c('button', {
      staticClass: "btn btn-primary btn-xs",
      staticStyle: {
        "border-radius": "0px",
        "padding": "0.3rem 0.5rem"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showDebitFromModal(val.ShippingID)
        }
      }
    }, [_vm._v("\n                                        Show Details")])])]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val.DocketNumber ? val.DocketNumber : "-"))]), _vm._v(" "), _c('td', {
      staticClass: "word-wraptd"
    }, [_vm._v(" " + _vm._s(_vm._f("moment2")(val.CreatedDate)))]), _vm._v(" "), _c('td', {
      staticClass: "word-wraptd"
    }, [_vm._v(" " + _vm._s(_vm._f("moment")(val.LastModifiedDate)))]), _vm._v(" "), _c('td', {
      staticClass: "word-wraptd"
    }, [_vm._v(" " + _vm._s(val.CreatedBy ? val.CreatedBy : "-"))]), _vm._v(" "), _c('td', {
      staticClass: "word-wraptd"
    }, [_vm._v(" " + _vm._s(val.Comments ? val.Comments : "-"))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.getShipmentAttachmentPopup(val.ShippingID)
        }
      }
    }, [_vm._v("View Image")])])])
  })], 2)])]), _vm._v(" "), _c('div', [_c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.Loading
    },
    on: {
      "update:active": function($event) {
        _vm.Loading = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    staticClass: "rmApprove",
    attrs: {
      "size": "lg",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeApprovalResultModel.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.modelValue),
      callback: function($$v) {
        _vm.modelValue = $$v
      },
      expression: "modelValue"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title1"
  }, [_vm._v("Approval Debit Status")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeApprovalResultModel.apply(null, arguments)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isPendingGroupIdLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isPendingGroupIdLoader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 mb-3"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Total Selected : " + _vm._s(_vm.totalSelectedRecords) + "  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 mb-3",
    staticStyle: {
      "text-align": "end"
    }
  }, [_c('span', [_vm._v("Total Debit Amount: "), _c('b', [_vm._v(_vm._s(_vm.totalDebitAmount) + " ₹")])])])]), _vm._v(" "), _c('table', {
    staticClass: "b-table table table-bordered",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Sr No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Message")])])]), _vm._v(" "), _c('tbody', [(_vm.approvalDebitResultStatus.length > 0) ? _vm._l((_vm.approvalDebitResultStatus), function(row, index) {
    return _c('tr', {
      key: index,
      style: (row.code == 200 ? _vm.styleObjectSuccess : _vm.styleObjectFailure)
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.shippingIDs))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.message))])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm mt-4",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeApprovalResultModel()
      }
    }
  }, [_vm._v("close")])])])])]), _vm._v(" "), _c('b-modal', {
    staticClass: "rmApprove",
    attrs: {
      "size": "modal-dialog modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.getAttachmentFlag = false
      }
    },
    model: {
      value: (_vm.getAttachmentFlag),
      callback: function($$v) {
        _vm.getAttachmentFlag = $$v
      },
      expression: "getAttachmentFlag"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.attachmentLoader
    },
    on: {
      "update:active": function($event) {
        _vm.attachmentLoader = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Attachment ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeAttachmentPopup
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 lg-auto"
  }, [_c('table', {
    staticClass: "PopupraiseRMDebitNoteEditTable",
    attrs: {
      "cellpadding": "5px",
      "cellspacing": "5px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Attachment")])])]), _vm._v(" "), _c('tbody', [(_vm.getAttachmentListData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "align": "center"
    }
  }, [_vm._v("No Attachments Available.! ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getAttachmentListData), function(val, index) {
    return _c('tr', [_c('td', [_vm._v(" " + _vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": val.filePath,
        "target": "_blank",
        "title": val.fileName
      }
    }, [_vm._v(" " + _vm._s(val.fileName))])])])
  })], 2)])])])])], 1), _vm._v(" "), _c('b-modal', {
    staticClass: "rmApprove",
    attrs: {
      "size": "modal-dialog modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.debitFromModal = false
      }
    },
    model: {
      value: (_vm.debitFromModal),
      callback: function($$v) {
        _vm.debitFromModal = $$v
      },
      expression: "debitFromModal"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.attachmentLoader
    },
    on: {
      "update:active": function($event) {
        _vm.attachmentLoader = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("SR Debit Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeDebitFromModal
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 lg-auto",
    class: {
      'isScroll': _vm.isScroll
    }
  }, [_c('table', {
    staticClass: "PopupraiseRMDebitNoteEditTable",
    attrs: {
      "cellpadding": "5px",
      "cellspacing": "5px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr. No.")]), _vm._v(" "), _c('th', [_vm._v("ShippingID")]), _vm._v(" "), _c('th', [_vm._v("Debit SR Name")]), _vm._v(" "), _c('th', [_vm._v("Debit SR ID")]), _vm._v(" "), _c('th', [_vm._v("Debit Amount")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.debitPersonDetails), function(val1, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val1.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val1.SRName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val1.UserID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val1.DebitAmount ? val1.DebitAmount : 0) + " ₹")])])
  }), 0)])])])])], 1), _vm._v(" "), _c('b-modal', {
    staticClass: "rmApprove",
    attrs: {
      "size": "modal-dialog modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.debitAgencyModal = false
      }
    },
    model: {
      value: (_vm.debitAgencyModal),
      callback: function($$v) {
        _vm.debitAgencyModal = $$v
      },
      expression: "debitAgencyModal"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.attachmentLoader
    },
    on: {
      "update:active": function($event) {
        _vm.attachmentLoader = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Debit Agency Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeDebitAgencyModal
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 lg-auto",
    class: {
      'isScroll': _vm.isScroll
    }
  }, [_c('table', {
    staticClass: "PopupraiseRMDebitNoteEditTable",
    attrs: {
      "cellpadding": "5px",
      "cellspacing": "5px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr. No.")]), _vm._v(" "), _c('th', [_vm._v("ShippingID")]), _vm._v(" "), _c('th', [_vm._v("Debit Agency Name")]), _vm._v(" "), _c('th', [_vm._v("Debit Agency ID")]), _vm._v(" "), _c('th', [_vm._v("Debit Amount")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.debitAgencyDetails), function(val1, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(val1.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val1.DebitFrom))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val1.DebitID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val1.DebitAmount ? val1.DebitAmount : 0) + " ₹")])])
  }), 0)])])])])], 1)], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('legend', [_vm._v("Store Approval")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0691851d","hasScoped":true}!./src/views/components/LOST/StoreApproval/StoreApproval.component.html
// module id = 1566
// module chunks = 1